import './modalWrapper.scss';

import Slip from '../../../assets/images/icons/slip.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch } from '../../../features';
import { setModalSignInUp } from '../../../store/AppSlice';
import { modalTypeEnum } from '../../../types/modal';
import { ActionButton } from '../action-button/actionButton';

export const ModalInfoSlippage: FunctionComponent = () => {

    const dispatch = useAppDispatch()

    const handleClick = () => {
        dispatch(setModalSignInUp(modalTypeEnum.none));
    }
    
    return(
        <div className="modal modal-info">
            <div className="slippage-info">
                <img src={Slip} alt="" />
                <h1>Oque é o slippage?</h1>
                <p>
                    Slippage é a diferença entre o preço esperado de uma transação e o preço real no momento da execução. Isso pode ocorrer em mercados financeiros, especialmente em ativos de alta volatilidade ou baixa liquidez.
                </p>

                <div className="divider"></div>

                <h3>- Causas do Slippage -</h3>
                <ul>
                    <li>
                        <span> Volatilidade do Mercado</span> – Se o preço do ativo muda rapidamente, a ordem pode ser executada a um valor diferente do esperado.
                    </li>
                    <li>
                        <span> Baixa Liquidez</span> – Se houver poucos compradores ou vendedores no livro de ordens, sua ordem pode ser preenchida a um preço menos favorável.
                    </li>
                    <li>
                        <span> Tamanho da Ordem</span> – Ordens grandes podem não ser preenchidas a um único preço, pois precisam consumir várias ofertas do livro de ordens.
                    </li>
                </ul>

                <ActionButton stylish={'btn-green'} label={'Entendi'} onClick={handleClick}/>
            </div>
        </div>
    )
}